import React from "react"
import PubSub from "pubsub-js"
import { PaymentElement } from "@stripe/react-stripe-js"
import usePaymentSubmission from "./use-payment-submission"
import PlatformAuth from "aldoo-ra/PlatformAuth"

const { useAuth } = PlatformAuth

const CheckoutForm = ({ store, isActive }) => {
  const { handleSubmit, ready, setReady, isReady, loading } = usePaymentSubmission(store)
  const [auth] = useAuth()

  const { hideCheckout, showCart, getFragment, purchaseUserEmail, tempAuthForPurchase, purchaseFlow } = store

  const CheckoutTotalBar = getFragment("checkout-total-bar")
  // Optional project slot above the payment element (order summary…)
  const CheckoutFormHeader = getFragment("checkout-form-header")

  // Get email from auth, tempAuth, or purchaseUserEmail (in order of preference)
  const userEmail = auth?.email || tempAuthForPurchase?.email || purchaseUserEmail || ''

  // A flow may tune the Payment Element (fields collected, layout…):
  //   paymentElementOptions: (context) => ({ fields: { billingDetails: { address: "never" } } })
  const flowOptions = purchaseFlow?.flowDefinition?.paymentElementOptions
  const extraOptions = (typeof flowOptions === 'function' ? flowOptions({ store }) : flowOptions) || {}

  const handleBackToInvoice = () => {
    PubSub.publish("PURCHASE_FLOW_BACK")
  }

  const handlePaymentSubmit = async () => {
    // Email is already set up in handleEmailVerification (before checkout)
    // Complete payment with stored invoice data
    await handleSubmit(store.invoiceData, userEmail)
  }

  // Update button state via PubSub - only when this step is active
  React.useEffect(() => {
    if (!isActive) {
      return
    }

    PubSub.publish("PURCHASE_FLOW_UPDATE_BUTTON", {
      stepId: 'payment',
      onContinue: handlePaymentSubmit,
      onBack: handleBackToInvoice,
      canContinue: isReady && !loading,
      loading: loading
    })
  }, [isReady, loading, isActive])

  return (
    <div className="h-full flex flex-col justify-between">
      <div className="pt-8 pb-[70px] px-2 md:px-6">
        {CheckoutFormHeader && <CheckoutFormHeader store={store} />}
        <div className="mb-4" data-testid="checkout-payment-form">
          <PaymentElement
            onReady={() => setReady(true)}
            options={{
              defaultValues: {
                billingDetails: {
                  email: userEmail
                }
              },
              ...extraOptions,
            }}
          />
        </div>
      </div>

      {/* Invoice link + total - Sticky Bottom */}
      <CheckoutTotalBar store={store} />
    </div>
  )
}

export default CheckoutForm
